const dev = {
  api: {
    ENDPOINT: "https://dev.playspacebrain.io/app",
  },
  ENVIRONMENT: 'Development'
};

const qa = {
  api: {
    ENDPOINT: "https://qa.playspacebrain.com/app",
  },
  ENVIRONMENT: 'QA'
};

const prod = {
  api: {
    ENDPOINT: "https://app.playspacebrain.com/app",
  },
  ENVIRONMENT: 'Production'
};

const config = determineConfig();

function determineConfig() {
  switch (process.env.REACT_APP_ENV) {
    case "production":
      return prod;
    case "qa":
      console.dir(process.env.REACT_APP_ENV);
      return qa;
    default:
      console.dir(process.env.REACT_APP_ENV);
      return dev;
  }
}

export default {
  // Add common config values here
  ...config
};